export default () => {
    return {
        mounted(delay = this.$store.animationDelay, scrollTrigger = true) {
            let stSettings = false;

            if (scrollTrigger) {
                stSettings = {
                    start: 'top 85%',
                    trigger: this.$refs.element
                };
            }

            gsap.to(this.$refs.element, {
                autoAlpha: 0,
                duration: 0.5,
                delay: delay,
                ease: 'quad.out',
                scrollTrigger: stSettings
            });
        }
    };
};
